import { ROUTE_PATH } from '@/constants/routePath'
import { LIVE_MALL_CLUB_ROUTE_QUERY_STRING, RouteQueryStringKeyType } from '@/constants/routeQueryString'
import { useRouter } from 'next/router'

import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'
const useQueryParamsNavigation = () => {
  const router = useRouter()

  const handleNavigation = (targetKey: RouteQueryStringKeyType) => {
    switch (targetKey) {
      case 'PROFILE_MORE_MENU_OPEN':
        handleRoutePushWithQuery({
          router,
          pathname: ROUTE_PATH.PROFILE,
          query: LIVE_MALL_CLUB_ROUTE_QUERY_STRING.PROFILE_MORE_MENU_OPEN,
        })
        break
      default:
        break
    }
  }
  return { handleNavigation }
}

export default useQueryParamsNavigation
